export default __webpack_public_path__ + "static/media/phone2.5223200e.svg";